{
  "completed": "Dokončené: ",
  "current": "Aktuálne: ",
  "notCompleted": "Nedokončené: ",
  "steplist": "Zoznam krokov"
}
